import { ObjectFieldsChecker } from "../../../../../tools/ObjectFieldsChecker";
import { LatestNewsItemDto } from "../../../../networking/data/responses/latestnews/LatestNewsItemDto";
import { LatestNewsGuest } from "./LatestNewsGuest";
import { LatestNewsPrice } from "./LatestNewsPrice";
import { LatestNewsType } from "./LatestNewsType";
import { NewsRaidElementsToDowngrade } from "./NewsRaidElementsToDowngrade";

export class LatestNewsItem {
    public readonly id: string;
    public readonly type: LatestNewsType;
    public readonly rewardInCoins?: number;
    public readonly rewardInTokens?: number;
    public readonly buildingRankUpLevel?: number;
    public readonly buildingAddress?: string;
    public readonly guest?: LatestNewsGuest;
    public readonly downgradedElements?: NewsRaidElementsToDowngrade[];
    public readonly leaderboardEndsAt?: number;
    public readonly leaderboardPlace?: number;
    public readonly stealAmountInCoins?: number;
    public readonly transactionScanUrl?: string;
    public readonly price?: LatestNewsPrice;
    public readonly piggyBankRewardInTokens?: number;

    public constructor(dto: LatestNewsItemDto) {
        this.validateDto(dto);
        this.id = dto.id;
        this.type = dto.type as LatestNewsType;
        this.rewardInCoins = dto.rewardInCoins ?? 0;
        this.rewardInTokens = Number(dto.rewardInTokens) ?? 0;
        this.buildingRankUpLevel = dto.buildingRankUpLevel ?? 0;
        this.buildingAddress = dto.buildingAddress ?? "";
        this.guest = dto.guest != null ? new LatestNewsGuest(dto.guest) : null;
        this.downgradedElements = dto.downgradedElements?.map(item => new NewsRaidElementsToDowngrade(item)) ?? [];
        this.leaderboardEndsAt = dto.leaderboardEndsAt ?? 0;
        this.leaderboardPlace = dto.leaderboardPlace ?? 0;
        this.stealAmountInCoins = dto.stealAmountInCoins ?? 0;
        this.transactionScanUrl = dto.transactionScanUrl ?? "";
        this.price = dto.price != null ? new LatestNewsPrice(dto.price) : null;
        this.piggyBankRewardInTokens = Number(dto.piggyBankRewardInTokens) ?? 0;
    }

    private validateDto(dto: LatestNewsItemDto): void {
        ObjectFieldsChecker.throwIfInvalidFields(dto, [
            "id",
            "type"
        ]);
    }
}
